import { jsx as _jsx } from "react/jsx-runtime";
import ChartTooltipAction from "../index";
import * as Url from "../../../lib/charts/url-generation";
export default function ViewSessionsAction(props) {
    const { type, point } = props;
    const url = (() => {
        switch (type) {
            case "timeseries":
                return Url.viewSessionsFromTimeSeries(point);
            case "distribution":
                return Url.viewSessionsFromDistribution(point);
            case "map":
                return Url.viewSessionsFromMap(point);
        }
    })();
    if (url) {
        return (_jsx(ChartTooltipAction, { icon: "eye", children: _jsx("a", { href: url.href, children: "View Sessions" }) }));
    }
    return null;
}
